"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-transfer.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-transfer.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferReasonToJSON = exports.transferReasonFromJSON = exports.transferTypeToJSON = exports.transferTypeFromJSON = exports.CryptoTransferContext = exports.TransferPaymentContext = exports.TransferReason = exports.TransferType = void 0;
const amount_1 = require("../common/amount");
const quote_1 = require("../common/quote");
const savings_goal_1 = require("../common/savings-goal");
const protobufPackage = 'com.step.common.proto';
var TransferType;
(function (TransferType) {
    TransferType["INVALID_TRANSFER_TYPE"] = "INVALID_TRANSFER_TYPE";
    TransferType["STEP_CREDIT"] = "STEP_CREDIT";
    TransferType["INTERNAL"] = "INTERNAL";
    TransferType["BILL_PAY"] = "BILL_PAY";
    TransferType["INTER_ACCOUNT"] = "INTER_ACCOUNT";
    TransferType["CRYPTO"] = "CRYPTO";
    TransferType["CASH_DEPOSIT_REV_SHARE"] = "CASH_DEPOSIT_REV_SHARE";
    TransferType["RECOUPMENT"] = "RECOUPMENT";
    TransferType["USER_TO_STEP"] = "USER_TO_STEP";
    TransferType["INTEREST_CREDIT"] = "INTEREST_CREDIT";
    TransferType["FEE_CREDIT"] = "FEE_CREDIT";
    TransferType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferType || (exports.TransferType = TransferType = {}));
/**
 * Sub-categorization of transfers. Primarily to allow us to categorize and
 * track the spend of Step credits.
 */
var TransferReason;
(function (TransferReason) {
    TransferReason["INVALID_TRANSFER_REASON"] = "INVALID_TRANSFER_REASON";
    /**
     * SCHOOL_PROGRAM - Used by marketing for school program
     */
    TransferReason["SCHOOL_PROGRAM"] = "SCHOOL_PROGRAM";
    /**
     * GRADUATION - Used by marketing for graduation flow
     */
    TransferReason["GRADUATION"] = "GRADUATION";
    TransferReason["CORRECTION"] = "CORRECTION";
    /**
     * REIMBURSE_FEES_ATM - CX uses REIMBURSE_FEES reasons to reimburse disputed commissions
     */
    TransferReason["REIMBURSE_FEES_ATM"] = "REIMBURSE_FEES_ATM";
    TransferReason["REIMBURSE_FEES_CARD_REPLACEMENT"] = "REIMBURSE_FEES_CARD_REPLACEMENT";
    TransferReason["REIMBURSE_FEES_PAY_OVER_TIME"] = "REIMBURSE_FEES_PAY_OVER_TIME";
    TransferReason["REIMBURSE_FEES_MINIMUM_FUNDING"] = "REIMBURSE_FEES_MINIMUM_FUNDING";
    TransferReason["REIMBURSE_FEES_INSTANT_CASH_OUT"] = "REIMBURSE_FEES_INSTANT_CASH_OUT";
    /**
     * ACCOUNT_TO_ACCOUNT_TRANSFER - Used to move money from one user to another.
     */
    TransferReason["ACCOUNT_TO_ACCOUNT_TRANSFER"] = "ACCOUNT_TO_ACCOUNT_TRANSFER";
    /**
     * GOOD_FAITH - Used to reward users for bug-reporting / good faith
     */
    TransferReason["GOOD_FAITH"] = "GOOD_FAITH";
    /**
     * REFERRAL_TROUBLESHOOTING - Used to pay referral credit that wasn’t correctly issued due to bug or issue
     */
    TransferReason["REFERRAL_TROUBLESHOOTING"] = "REFERRAL_TROUBLESHOOTING";
    /**
     * REFERRAL_FRAUD - Used to recoup credit received from confirmed referral fraud
     */
    TransferReason["REFERRAL_FRAUD"] = "REFERRAL_FRAUD";
    /**
     * CONTENT_SOCIAL - Used by marketing for social ad
     */
    TransferReason["CONTENT_SOCIAL"] = "CONTENT_SOCIAL";
    /**
     * INTERVIEW_CREDIT - Used to issue credit for UX research
     */
    TransferReason["INTERVIEW_CREDIT"] = "INTERVIEW_CREDIT";
    /**
     * FINANCE_USE - Used by finance team to pay invoices via Step account
     */
    TransferReason["FINANCE_USE"] = "FINANCE_USE";
    /**
     * REGULATION_E_CLAIM - Used to fund provisional credit when user makes a Regulation E claim
     */
    TransferReason["REGULATION_E_CLAIM"] = "REGULATION_E_CLAIM";
    /**
     * MISSING_CASH_DEPOSIT - Used to fund credit from missing cash deposit. Must be reconciled manually by Finance
     */
    TransferReason["MISSING_CASH_DEPOSIT"] = "MISSING_CASH_DEPOSIT";
    /**
     * ISSUING_DISPUTE_LOST - Used to fill account due to dispute lost to recognize loss
     */
    TransferReason["ISSUING_DISPUTE_LOST"] = "ISSUING_DISPUTE_LOST";
    /**
     * FRAUD_RECOGNIZE_LOSS - Used to fill account to recognize loss
     */
    TransferReason["FRAUD_RECOGNIZE_LOSS"] = "FRAUD_RECOGNIZE_LOSS";
    /**
     * MARKETING_OTHER - Used by marketing for any any other marketing activities
     */
    TransferReason["MARKETING_OTHER"] = "MARKETING_OTHER";
    /**
     * REWARDS_PAYOUT - Used by CX for manual rewards if rewards payouts fail
     */
    TransferReason["REWARDS_PAYOUT"] = "REWARDS_PAYOUT";
    /**
     * MARKETING_REWARDS_PAYOUT - Used for marketing rewards.
     */
    TransferReason["MARKETING_REWARDS_PAYOUT"] = "MARKETING_REWARDS_PAYOUT";
    /**
     * POINTS_REDEMPTION - Used by CX for manual points redemption adjustments.
     */
    TransferReason["POINTS_REDEMPTION"] = "POINTS_REDEMPTION";
    /**
     * LOSS_RECOGNITION_REVERSAL - Reverse an earlier recognition of loss.
     */
    TransferReason["LOSS_RECOGNITION_REVERSAL"] = "LOSS_RECOGNITION_REVERSAL";
    TransferReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferReason || (exports.TransferReason = TransferReason = {}));
function createBaseTransferPaymentContext() {
    return {
        type: TransferType.INVALID_TRANSFER_TYPE,
        sourceSavingsGoal: undefined,
        destinationSavingsGoal: undefined,
        reason: TransferReason.INVALID_TRANSFER_REASON,
        crypto: undefined,
    };
}
exports.TransferPaymentContext = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? transferTypeFromJSON(object.type)
                : TransferType.INVALID_TRANSFER_TYPE,
        };
        if (isSet(object.sourceSavingsGoal)) {
            message.sourceSavingsGoal = savings_goal_1.SavingsGoal.fromJSON(object.sourceSavingsGoal);
        }
        if (isSet(object.destinationSavingsGoal)) {
            message.destinationSavingsGoal = savings_goal_1.SavingsGoal.fromJSON(object.destinationSavingsGoal);
        }
        if (isSet(object.reason)) {
            message.reason = transferReasonFromJSON(object.reason);
        }
        if (isSet(object.crypto)) {
            message.crypto = exports.CryptoTransferContext.fromJSON(object.crypto);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== TransferType.INVALID_TRANSFER_TYPE) {
            obj.type = transferTypeToJSON(message.type);
        }
        if (message.sourceSavingsGoal !== undefined) {
            obj.sourceSavingsGoal = savings_goal_1.SavingsGoal.toJSON(message.sourceSavingsGoal);
        }
        if (message.destinationSavingsGoal !== undefined) {
            obj.destinationSavingsGoal = savings_goal_1.SavingsGoal.toJSON(message.destinationSavingsGoal);
        }
        if (message.reason !== undefined && message.reason !== TransferReason.INVALID_TRANSFER_REASON) {
            obj.reason = transferReasonToJSON(message.reason);
        }
        if (message.crypto !== undefined) {
            obj.crypto = exports.CryptoTransferContext.toJSON(message.crypto);
        }
        return obj;
    },
    create(base) {
        return exports.TransferPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferPaymentContext();
        message.type = object.type ?? TransferType.INVALID_TRANSFER_TYPE;
        message.sourceSavingsGoal =
            (object.sourceSavingsGoal !== undefined && object.sourceSavingsGoal !== null)
                ? savings_goal_1.SavingsGoal.fromPartial(object.sourceSavingsGoal)
                : undefined;
        message.destinationSavingsGoal =
            (object.destinationSavingsGoal !== undefined && object.destinationSavingsGoal !== null)
                ? savings_goal_1.SavingsGoal.fromPartial(object.destinationSavingsGoal)
                : undefined;
        message.reason = object.reason ?? TransferReason.INVALID_TRANSFER_REASON;
        message.crypto = (object.crypto !== undefined && object.crypto !== null)
            ? exports.CryptoTransferContext.fromPartial(object.crypto)
            : undefined;
        return message;
    },
};
function createBaseCryptoTransferContext() {
    return { price: undefined, withdrawalQuote: undefined, executedWithdrawalQuote: undefined };
}
exports.CryptoTransferContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.price)) {
            message.price = amount_1.Amount.fromJSON(object.price);
        }
        if (isSet(object.withdrawalQuote)) {
            message.withdrawalQuote = quote_1.WithdrawalQuote.fromJSON(object.withdrawalQuote);
        }
        if (isSet(object.executedWithdrawalQuote)) {
            message.executedWithdrawalQuote = quote_1.ExecutedWithdrawalQuote.fromJSON(object.executedWithdrawalQuote);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        if (message.withdrawalQuote !== undefined) {
            obj.withdrawalQuote = quote_1.WithdrawalQuote.toJSON(message.withdrawalQuote);
        }
        if (message.executedWithdrawalQuote !== undefined) {
            obj.executedWithdrawalQuote = quote_1.ExecutedWithdrawalQuote.toJSON(message.executedWithdrawalQuote);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoTransferContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoTransferContext();
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : undefined;
        message.withdrawalQuote =
            (object.withdrawalQuote !== undefined && object.withdrawalQuote !== null)
                ? quote_1.WithdrawalQuote.fromPartial(object.withdrawalQuote)
                : undefined;
        message.executedWithdrawalQuote =
            (object.executedWithdrawalQuote !== undefined && object.executedWithdrawalQuote !== null)
                ? quote_1.ExecutedWithdrawalQuote.fromPartial(object.executedWithdrawalQuote)
                : undefined;
        return message;
    },
};
function transferTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TRANSFER_TYPE':
            return TransferType.INVALID_TRANSFER_TYPE;
        case 2:
        case 'STEP_CREDIT':
            return TransferType.STEP_CREDIT;
        case 3:
        case 'INTERNAL':
            return TransferType.INTERNAL;
        case 4:
        case 'BILL_PAY':
            return TransferType.BILL_PAY;
        case 5:
        case 'INTER_ACCOUNT':
            return TransferType.INTER_ACCOUNT;
        case 6:
        case 'CRYPTO':
            return TransferType.CRYPTO;
        case 7:
        case 'CASH_DEPOSIT_REV_SHARE':
            return TransferType.CASH_DEPOSIT_REV_SHARE;
        case 8:
        case 'RECOUPMENT':
            return TransferType.RECOUPMENT;
        case 9:
        case 'USER_TO_STEP':
            return TransferType.USER_TO_STEP;
        case 10:
        case 'INTEREST_CREDIT':
            return TransferType.INTEREST_CREDIT;
        case 11:
        case 'FEE_CREDIT':
            return TransferType.FEE_CREDIT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferType.UNRECOGNIZED;
    }
}
exports.transferTypeFromJSON = transferTypeFromJSON;
function transferTypeToJSON(object) {
    switch (object) {
        case TransferType.INVALID_TRANSFER_TYPE:
            return 'INVALID_TRANSFER_TYPE';
        case TransferType.STEP_CREDIT:
            return 'STEP_CREDIT';
        case TransferType.INTERNAL:
            return 'INTERNAL';
        case TransferType.BILL_PAY:
            return 'BILL_PAY';
        case TransferType.INTER_ACCOUNT:
            return 'INTER_ACCOUNT';
        case TransferType.CRYPTO:
            return 'CRYPTO';
        case TransferType.CASH_DEPOSIT_REV_SHARE:
            return 'CASH_DEPOSIT_REV_SHARE';
        case TransferType.RECOUPMENT:
            return 'RECOUPMENT';
        case TransferType.USER_TO_STEP:
            return 'USER_TO_STEP';
        case TransferType.INTEREST_CREDIT:
            return 'INTEREST_CREDIT';
        case TransferType.FEE_CREDIT:
            return 'FEE_CREDIT';
        case TransferType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferTypeToJSON = transferTypeToJSON;
function transferReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TRANSFER_REASON':
            return TransferReason.INVALID_TRANSFER_REASON;
        case 1:
        case 'SCHOOL_PROGRAM':
            return TransferReason.SCHOOL_PROGRAM;
        case 2:
        case 'GRADUATION':
            return TransferReason.GRADUATION;
        case 3:
        case 'CORRECTION':
            return TransferReason.CORRECTION;
        case 4:
        case 'REIMBURSE_FEES_ATM':
            return TransferReason.REIMBURSE_FEES_ATM;
        case 5:
        case 'REIMBURSE_FEES_CARD_REPLACEMENT':
            return TransferReason.REIMBURSE_FEES_CARD_REPLACEMENT;
        case 6:
        case 'REIMBURSE_FEES_PAY_OVER_TIME':
            return TransferReason.REIMBURSE_FEES_PAY_OVER_TIME;
        case 7:
        case 'REIMBURSE_FEES_MINIMUM_FUNDING':
            return TransferReason.REIMBURSE_FEES_MINIMUM_FUNDING;
        case 8:
        case 'REIMBURSE_FEES_INSTANT_CASH_OUT':
            return TransferReason.REIMBURSE_FEES_INSTANT_CASH_OUT;
        case 9:
        case 'ACCOUNT_TO_ACCOUNT_TRANSFER':
            return TransferReason.ACCOUNT_TO_ACCOUNT_TRANSFER;
        case 10:
        case 'GOOD_FAITH':
            return TransferReason.GOOD_FAITH;
        case 11:
        case 'REFERRAL_TROUBLESHOOTING':
            return TransferReason.REFERRAL_TROUBLESHOOTING;
        case 12:
        case 'REFERRAL_FRAUD':
            return TransferReason.REFERRAL_FRAUD;
        case 13:
        case 'CONTENT_SOCIAL':
            return TransferReason.CONTENT_SOCIAL;
        case 14:
        case 'INTERVIEW_CREDIT':
            return TransferReason.INTERVIEW_CREDIT;
        case 15:
        case 'FINANCE_USE':
            return TransferReason.FINANCE_USE;
        case 16:
        case 'REGULATION_E_CLAIM':
            return TransferReason.REGULATION_E_CLAIM;
        case 17:
        case 'MISSING_CASH_DEPOSIT':
            return TransferReason.MISSING_CASH_DEPOSIT;
        case 18:
        case 'ISSUING_DISPUTE_LOST':
            return TransferReason.ISSUING_DISPUTE_LOST;
        case 19:
        case 'FRAUD_RECOGNIZE_LOSS':
            return TransferReason.FRAUD_RECOGNIZE_LOSS;
        case 20:
        case 'MARKETING_OTHER':
            return TransferReason.MARKETING_OTHER;
        case 21:
        case 'REWARDS_PAYOUT':
            return TransferReason.REWARDS_PAYOUT;
        case 22:
        case 'MARKETING_REWARDS_PAYOUT':
            return TransferReason.MARKETING_REWARDS_PAYOUT;
        case 23:
        case 'POINTS_REDEMPTION':
            return TransferReason.POINTS_REDEMPTION;
        case 24:
        case 'LOSS_RECOGNITION_REVERSAL':
            return TransferReason.LOSS_RECOGNITION_REVERSAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferReason.UNRECOGNIZED;
    }
}
exports.transferReasonFromJSON = transferReasonFromJSON;
function transferReasonToJSON(object) {
    switch (object) {
        case TransferReason.INVALID_TRANSFER_REASON:
            return 'INVALID_TRANSFER_REASON';
        case TransferReason.SCHOOL_PROGRAM:
            return 'SCHOOL_PROGRAM';
        case TransferReason.GRADUATION:
            return 'GRADUATION';
        case TransferReason.CORRECTION:
            return 'CORRECTION';
        case TransferReason.REIMBURSE_FEES_ATM:
            return 'REIMBURSE_FEES_ATM';
        case TransferReason.REIMBURSE_FEES_CARD_REPLACEMENT:
            return 'REIMBURSE_FEES_CARD_REPLACEMENT';
        case TransferReason.REIMBURSE_FEES_PAY_OVER_TIME:
            return 'REIMBURSE_FEES_PAY_OVER_TIME';
        case TransferReason.REIMBURSE_FEES_MINIMUM_FUNDING:
            return 'REIMBURSE_FEES_MINIMUM_FUNDING';
        case TransferReason.REIMBURSE_FEES_INSTANT_CASH_OUT:
            return 'REIMBURSE_FEES_INSTANT_CASH_OUT';
        case TransferReason.ACCOUNT_TO_ACCOUNT_TRANSFER:
            return 'ACCOUNT_TO_ACCOUNT_TRANSFER';
        case TransferReason.GOOD_FAITH:
            return 'GOOD_FAITH';
        case TransferReason.REFERRAL_TROUBLESHOOTING:
            return 'REFERRAL_TROUBLESHOOTING';
        case TransferReason.REFERRAL_FRAUD:
            return 'REFERRAL_FRAUD';
        case TransferReason.CONTENT_SOCIAL:
            return 'CONTENT_SOCIAL';
        case TransferReason.INTERVIEW_CREDIT:
            return 'INTERVIEW_CREDIT';
        case TransferReason.FINANCE_USE:
            return 'FINANCE_USE';
        case TransferReason.REGULATION_E_CLAIM:
            return 'REGULATION_E_CLAIM';
        case TransferReason.MISSING_CASH_DEPOSIT:
            return 'MISSING_CASH_DEPOSIT';
        case TransferReason.ISSUING_DISPUTE_LOST:
            return 'ISSUING_DISPUTE_LOST';
        case TransferReason.FRAUD_RECOGNIZE_LOSS:
            return 'FRAUD_RECOGNIZE_LOSS';
        case TransferReason.MARKETING_OTHER:
            return 'MARKETING_OTHER';
        case TransferReason.REWARDS_PAYOUT:
            return 'REWARDS_PAYOUT';
        case TransferReason.MARKETING_REWARDS_PAYOUT:
            return 'MARKETING_REWARDS_PAYOUT';
        case TransferReason.POINTS_REDEMPTION:
            return 'POINTS_REDEMPTION';
        case TransferReason.LOSS_RECOGNITION_REVERSAL:
            return 'LOSS_RECOGNITION_REVERSAL';
        case TransferReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferReasonToJSON = transferReasonToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-transfer.js.map